import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VuexPersistence from 'vuex-persist'
import VueAuthenticate from 'vue-authenticate'
import router from '@/router'
import printJS from 'print-js'
import config from '@/config/index'
import address from './modules/address'
import cashBill from './modules/cashBill'
import customer from './modules/customer'
import quotation from './modules/quotation'
import invoice from './modules/invoice'
import receipt from './modules/receipt'
import report from './modules/report'
import systemSetting from './modules/systemSetting'
import officer from './modules/officer'
import gang from './modules/gang'

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: config.serverURI,
  loginUrl: '/login',
  logoutUrl: '/logout',
  validateUrl: '/validate',
  tokenName: 'access_token',
  requestDataKey: 'data',
  responseDataKey: 'data',
  bindRequestInterceptor: function () {
    this.$http.interceptors.request.use((config) => {
      if (this.isAuthenticated()) {
        config.headers['Authorization'] = [
          this.options.tokenType, this.getToken()
        ].join(' ')
      } else {
        delete config.headers['Authorization']
      }
      return config
    })
  }
})

const vueAuth = Vue.prototype.$auth

Vue.axios.interceptors.response.use((response) => {
  vueAuth.setToken(response)
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    router.push({ path: '/logout' })
  }
  return Promise.reject(error)
})

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

function initialState () {
  return {
    drawer: true,
    miniVariant: false,
    profile: {},
    isAuthenticated: false
  }
}

const store = new Vuex.Store({
  state: initialState,
  getters: {
    serverURI () {
      return config.serverURI
    },
    token (state) {
      return state.profile.access_token
    },
    roles (state) {
      return (state.profile.roles) ? state.profile.roles : []
    },
    username (state) {
      return state.profile.username
    },
    fullname (state) {
      return state.profile.fullname
    },
    email (state) {
      return state.profile.email
    },
    vat (state) {
      let found = (state.systemSettings) ? state.systemSettings.find(v => v.id === 'vat.percentage') : null
      return (found) ? found.value : 0.0
    },
    taxId (state) {
      let found = (state.systemSettings) ? state.systemSettings.find(v => v.id === 'company.tax_id') : null
      return (found) ? found.value : ''
    }
  },

  mutations: {
    drawer (state, drawer) {
      state.drawer = drawer
    },
    miniVariant (state, miniVariant) {
      state.miniVariant = miniVariant
    },
    isAuthenticated (state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },
    profile (state, profile) {
      state.profile = profile
    },
    reset (state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },

  actions: {
    login (context, payload) {
      payload = payload || {}
      if (vueAuth.isAuthenticated()) {
        vueAuth.logout()
      }
      return vueAuth.login(payload.user, payload.requestOptions)
        .then((response) => {
          context.commit('isAuthenticated', vueAuth.isAuthenticated())
          context.commit('profile', response.data)
          return response
        })
    },
    logout (context, payload) {
      payload = payload || {}
      return vueAuth.logout(payload.requestOptions)
        .then(() => {
          context.commit('isAuthenticated', false)
          context.commit('profile', {})
          context.commit('reset')
        }).catch(() => {
          context.commit('isAuthenticated', false)
          context.commit('profile', {})
          context.commit('reset')
        })
    },
    printPdf ({ commit, dispatch, getters }, url) {
      printJS({printable: url, type: 'pdf', showModal: true})
    }
  },

  modules: {
    address,
    customer,
    cashBill,
    quotation,
    invoice,
    receipt,
    report,
    officer,
    gang,
    systemSetting
  },
  plugins: [vuexLocal.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js